import DateFormatter from '@apigrowfinance/pbolt-date-formatter';

import { ITimelineItem } from '@clients/timelineClient';
import TimelineBlock from '@components/accountTimeline/accountTimelineBlock/TimelineBlock';
import { getYearAndMonth } from '@utils/dateUtil';

export type TimelineProps = {
    timeline: ITimelineItem[];
    showTooltip: boolean;
};

const Timeline = ({ timeline, showTooltip }: TimelineProps) => {
    // The logic in this module will take an array of timeline items,
    // Iterate over the list and check the month.
    // If the timeline item is within the current month, it gets added to the list of entries for the month, blockOf
    // If the next entry belongs to a different month, then batch the entries up and send them to TimelineBlock
    // and reset the batchOf for next months

    let blockNo = 0;
    const blockOf: ITimelineItem[] = [];

    return (
        <>
            {timeline?.map((aTimeline, index) => {
                const currentItemsYearMonth = getYearAndMonth(
                    aTimeline.timestamp,
                );

                const nextItemsYearMonth = getYearAndMonth(
                    timeline[index + 1] === undefined
                        ? aTimeline.timestamp
                        : timeline[index + 1].timestamp,
                );

                blockOf.push(aTimeline);

                // if we've moved on to a new block of dates
                if (
                    currentItemsYearMonth != nextItemsYearMonth ||
                    index == timeline.length - 1
                ) {
                    // make a copy of the timelineitems collected so far that match the year-month filter
                    const sendOver = JSON.parse(JSON.stringify(blockOf));

                    // reset the block of timeline items
                    blockOf.length = 0;
                    blockNo++;

                    return (
                        <TimelineBlock
                            key={blockNo}
                            heading={
                                <DateFormatter
                                    date={aTimeline.timestamp}
                                    format="monthYearFull"
                                />
                            }
                            timelineItems={sendOver}
                            showTooltip={showTooltip}
                        />
                    );
                } else {
                    return null;
                }
            })}
        </>
    );
};

export default Timeline;
